<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Equipment Association</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-columns"></i>
                    <span>Equipment Association </span>
                </li>
            </ol>
        </div>
    </div>
</div>

<staging-tabs></staging-tabs>

<!--<div>
    <ul class="nav navbar-nav">
        <li>
            Live
        </li>
        <li>Staged</li>
    </ul>
    <div class="component-container">
        <div class="component-content" [class.col-lg-4]="(minesiteVisible && equipmentVisible)" [class.col-lg-6]="(!minesiteVisible || !equipmentVisible) && !(!minesiteVisible && !equipmentVisible)" [class.col-lg-12]="(!minesiteVisible && !equipmentVisible)" *ngIf="companyVisible">
            <company-list class="association-list"></company-list>
        </div>
        <div class="component-content" [class.col-lg-4]="(companyVisible && equipmentVisible)" [class.col-lg-6]="(!companyVisible || !equipmentVisible) && !(!companyVisible && !equipmentVisible)" [class.col-lg-12]="(!companyVisible && !equipmentVisible)" *ngIf="minesiteVisible">
            <minesite-list class="association-list"></minesite-list>
        </div>
        <div class="component-content" [class.col-lg-4]="(companyVisible && minesiteVisible)" [class.col-lg-6]="(!companyVisible || !minesiteVisible) && !(!companyVisible && !minesiteVisible)" [class.col-lg-12]="(!companyVisible && !minesiteVisible)" *ngIf="equipmentVisible">
            <model-list class="association-list"></model-list>
        </div>
    </div>
</div>--
<div class="component-container">
    <div class="component-content" [class.col-lg-4]="(minesitevisible && equipmentvisible)" [class.col-lg-6]="(!minesitevisible || !equipmentvisible) && !(!minesitevisible && !equipmentvisible)" [class.col-lg-12]="(!minesitevisible && !equipmentvisible)" *ngIf="companyvisible">
        <company-list class="association-list"></company-list>
    </div>
    <div class="component-content" [class.col-lg-4]="(companyvisible && equipmentvisible)" [class.col-lg-6]="(!companyvisible || !equipmentvisible) && !(!companyvisible && !equipmentvisible)" [class.col-lg-12]="(!companyvisible && !equipmentvisible)" *ngIf="minesitevisible">
        <minesite-list class="association-list"></minesite-list>
    </div>
    <div class="component-content" [class.col-lg-4]="(companyvisible && minesitevisible)" [class.col-lg-6]="(!companyvisible || !minesitevisible) && !(!companyvisible && !minesitevisible)" [class.col-lg-12]="(!companyvisible && !minesitevisible)" *ngIf="equipmentvisible">
        <model-list class="association-list"></model-list>
    </div>
</div>-->

